import { PluginObject } from 'vue';
import { apiClientV2 } from '@/api/ApiClientV2';

export class ApiClientPluginV2 implements PluginObject<any> {
  install(vue, options): void {
    vue.prototype.$apiv2 = apiClientV2;
  }
}
